import Vue from 'vue'
import GoodChart from '@/components/GoodChart.vue'
import store from '@/store' // 导入 store
import i18n from '@/i18n' // 导入 i18n

const ChartConstructor = Vue.extend(GoodChart)

let instance = null

const showChartDialog = function(type = 'chat', item) {
  if (!instance) {
    instance = new ChartConstructor({
      el: document.createElement('div'),
      store, // 注入 store
      i18n, // 注入 i18n
      propsData: {
        type,
        item // 传入类型参数
      }
    })
    document.body.appendChild(instance.$el)
  } else {
    // 更新实例的type属性
    instance.type = type
    instance.item = item
  }
  instance.show()
}

export default {
  install(Vue) {
    // 注册三个不同的全局方法
    Vue.prototype.$chart = (type,item) => showChartDialog(type,item)
  }
} 